<script setup lang="ts">
const props = defineProps<{
  primary?: boolean;
}>();
</script>

<template>
  <component
    :is="props.primary ? 'h1' : 'h2'"
    class="ui-text-primary"
    :class="{ 'text-2xl font-semibold': props.primary, 'text-xl font-bold': !props.primary }"
  >
    <slot />
  </component>
</template>
